import React from 'react';
import Section from '../../../Components/Section/Section';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import Container from '../../../../../Common/Container/Container';
import ContactForm from '../../../../../Common/ContactForm/ContactForm';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { FormSectionProps } from '../../../../../Sections/GetInTouch/FormSection/FormSection';
import { Section as ISection } from '../../../../../../interfaces/Section';

const FormSection = ({ professionalID, template }: FormSectionProps & ISection) => {
  const { t } = useTranslation();
  return (
    <Section number={'02'} label={t('getInTouch.formSection.sectionTitle')}>
      <Container>
        <div className={'row'}>
          <div className={'col-xl-4 col-lg-4 col-md-5 col-sm-12'}>
            <SectionTitle>{t('getInTouch.formSection.titleText')}</SectionTitle>
          </div>
          <div className={'col-xl-7 col-lg-7 offset-md-1 col-md-6 col-sm-12'}>
            <ContactForm professionalID={professionalID} template={template} />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default FormSection;
